export default __webpack_public_path__ + "app/assets/favicon-406d1d21.png";